import { SvgIconProps } from '@mui/material';
import React from 'react';
import { StyledBadge } from './Badge.styles';

export interface BadgeProps {
  icon: (props: SvgIconProps) => JSX.Element;
}

const Badge: React.FC<BadgeProps> = ({ icon: Icon }: BadgeProps) => (
  <StyledBadge color='error' variant='dot' badgeContent='' overlap='circular'>
    <Icon fontSize='medium' />
  </StyledBadge>
);

export default Badge;
